import React, { useState } from 'react';
import { useTranslation } from '../Context/TranslationContext';

const AwardsPage = () => {
  const { isTamil } = useTranslation();
  const [selectedAward, setSelectedAward] = useState(null);
  const [hoveredId, setHoveredId] = useState(null);

  const translations = {
    en: {
      pageTitle: "Awards & Decorations",
      pageSubtitle: "Bharat Scouts and Guides Tamil Nadu",
      categories: {
        national: "National Awards",
        service: "Service Awards",
        special: "Special Recognition",
        regional: "Regional Awards"
      },
      viewDetails: "View Details",
      close: "Close",
      readMore: "Read More About This Award"
    },
    ta: {
      pageTitle: "விருதுகள் & அலங்காரங்கள்",
      pageSubtitle: "பாரத சாரணர் & சாரணியர் தமிழ்நாடு",
      categories: {
        national: "தேசிய விருதுகள்",
        service: "சேவை விருதுகள்",
        special: "சிறப்பு அங்கீகாரம்",
        regional: "பிராந்திய விருதுகள்"
      },
      viewDetails: "விவரங்களைக் காண",
      close: "மூடு",
      readMore: "இந்த விருது பற்றி மேலும் படிக்கவும்"
    }
  };

  const t = translations[isTamil ? 'ta' : 'en'];

  const awards = {
    national: [
      {
        id: "silver-elephant",
        title: isTamil ? "வெள்ளி யானை" : "Silver Elephant",
        subtitle: isTamil ? "மிக உயர்ந்த தேசிய விருது" : "Highest National Award",
        imageSrc: "/Images/silverelephant.png",
        description: isTamil 
          ? "இயக்கத்திற்கு விதிவிலக்கான சேவை செய்ததற்காக வழங்கப்படும் மிக உயர்ந்த தேசிய விருது."
          : "The highest National Award, presented for service of most exceptional character to the Movement.",
        details: isTamil 
          ? ["தேசிய தலைமை ஆணையாளரால் வழங்கப்படுகிறது", "நீலம், பச்சை மற்றும் சிவப்பு நிற ரிப்பனுடன் கூடிய விருது", "சீருடையில் சிறப்பு சந்தர்ப்பங்களில் மட்டுமே அணிய வேண்டும்"]
          : ["Awarded by the Chief National Commissioner", "Features a ribbon with blue, green, and red strands", "To be worn on uniform on special occasions only"]
      },
      {
        id: "silver-star",
        title: isTamil ? "வெள்ளி நட்சத்திரம்" : "Silver Star",
        subtitle: isTamil ? "சிறப்பு தொடர் சேவை விருது" : "Distinguished Service Award",
        imageSrc: "/Images/silverstar.png",
        description: isTamil
          ? "20 ஆண்டுகளுக்கும் மேலான சிறப்பான மற்றும் தொடர்ச்சியான சேவைக்காக வழங்கப்படுகிறது."
          : "Awarded for special distinguished and continuous service for 20 years and more.",
        details: isTamil
          ? ["மஞ்சள் ரிப்பனுடன் கூடிய ஐந்து முனை நட்சத்திரம்", "சாதனை சான்றிதழுடன் வழங்கப்படுகிறது", "5 ஆண்டுகள் கூடுதல் சேவைக்கு பார் வழங்கப்படுகிறது"]
          : ["Five-pointed Star with yellow ribbon", "Issued with a certificate of achievement", "Bar awarded for additional 5 years of service"]
      }
    ],
    regional: [
      {
        id: "ap-award",
        title: isTamil ? "ஆசிய பசிபிக் தலைமைத்துவ விருது" : "Asia Pacific Leadership Award",
        subtitle: isTamil ? "பிராந்திய சிறப்பு அங்கீகாரம்" : "Regional Excellence Recognition",
        imageSrc: "/Images/asiapacific.png",
        description: isTamil
          ? "ஆசிய பசிபிக் பிராந்திய அளவில் தலைவர்களின் சாதனைகளை அங்கீகரிக்க வழங்கப்படுகிறது."
          : "Recognizes achievement of leaders at the Asia Pacific Regional level.",
        details: isTamil
          ? ["வருடாந்திர ஆசிய பசிபிக் பிராந்திய குழு கூட்டத்தில் வழங்கப்படுகிறது", "சான்றிதழ் மற்றும் விருது பின் வழங்கப்படுகிறது", "சீருடையுடன் அல்லது சீருடை இல்லாமல் அணியலாம்"]
          : ["Presented annually at Asia Pacific Regional Committee meeting", "Certificate and award pin presented", "Pin may be worn in and out of uniform"]
      }
    ],
    service: [
        {
            id: "bar-to-medal",
            title: isTamil ? "தகுதி பதக்கத்திற்கான பார்" : "Bar to the Medal of Merit",
            subtitle: isTamil ? "கூடுதல் சேவை அங்கீகாரம்" : "Additional Service Recognition",
            imageSrc: "/Images/bartomedal.png",
            description: isTamil 
              ? "தகுதி பதக்கம் வழங்கப்பட்ட பின்னர் ஐந்து ஆண்டுகளுக்கும் மேலான கூடுதல் சேவைக்காக வழங்கப்படுகிறது."
              : "May be awarded for not less than five years of additional service of similar character after the award of Medal of Merit.",
            details: isTamil
              ? [
                  "தகுதி பதக்கத்திற்கான மேலதிக அங்கீகாரம்",
                  "குறைந்தபட்சம் 5 ஆண்டுகள் கூடுதல் சேவை தேவை",
                  "அசல் பதக்கத்துடன் இணைந்து அணியப்படுகிறது"
                ]
              : [
                  "Additional recognition to Medal of Merit",
                  "Requires minimum 5 years of additional service",
                  "Worn together with the original medal"
                ]
          },
      {
        id: "long-service",
        title: isTamil ? "நீண்ட கால சேவை அலங்காரம்" : "Long Service Decoration",
        subtitle: isTamil ? "10+ ஆண்டுகள் சேவை அங்கீகாரம்" : "10+ Years Service Recognition",
        imageSrc: "/Images/longservice.png",
        description: isTamil
          ? "10 ஆண்டுகளுக்கும் மேலாக நம்பிக்கையான மற்றும் திறமையான சேவை செய்த உறுப்பினர்களுக்கு."
          : "For warranted members with 10+ years of faithful and efficient service.",
        details: isTamil
          ? ["நீல நிற வளையத்தில் தங்க விளிம்புடன் கூடிய பதக்கம்", "ஒவ்வொரு 5 ஆண்டுகளுக்கும் புதுப்பிக்கப்படலாம்", "வலது பாக்கெட்டுக்கு மேலே அணிய வேண்டும்"]
          : ["Medallion with blue ring and gold border", "May be renewed every 5 years", "Worn above right pocket"]
      },
      {
        id: "service-stars",
        title: isTamil ? "சேவை நட்சத்திரங்கள்" : "Service Stars",
        subtitle: isTamil ? "வருடாந்திர சேவை அங்கீகாரம்" : "Annual Service Recognition",
        imageSrc: "/Images/servicestar.png",
        description: isTamil
          ? "ஒவ்வொரு ஆண்டு சேவைக்கும் வழங்கப்படும் விருது, பங்கின் அடிப்படையில் வெவ்வேறு நிறங்களில்."
          : "Awarded for each year of service, in different colors based on role.",
        details: isTamil
          ? ["உலோகத்தில் மட்டும் கிடைக்கும்", "ஆறு முனை நட்சத்திர வடிவம்", "பல்வேறு பிரிவுகளுக்கு வெவ்வேறு நிற பின்னணி"]
          : ["Available in metal only", "Six-pointed star design", "Different background colors for different sections"]
      }
    ],
    special: [
      {
        id: "gallantry",
        title: isTamil ? "வீரத்திற்கான விருது" : "Award for Gallantry",
        subtitle: isTamil ? "துணிச்சல் மற்றும் வீரத்திற்கான அங்கீகாரம்" : "Recognition for Bravery and Heroism",
        imageSrc: "/Images/gallantry.png",
        description: isTamil
          ? "வீரம் மற்றும் துணிச்சலான செயல்களுக்கு வழங்கப்படும் மூன்று நிலை விருதுகள்."
          : "Three-tier award system recognizing acts of bravery and heroism.",
        details: isTamil
          ? ["வெண்கல பதக்கம் - சிறப்பு வீரத்திற்கு", "வெள்ளி பதக்கம் - கணிசமான அபாயத்துடன் கூடிய வீரத்திற்கு", "தங்க பதக்கம் - மிதமான அபாயத்துடன் கூடிய வீரத்திற்கு"]
          : ["Bronze Medal - For special heroism", "Silver Medal - For gallantry with considerable risk", "Gilt Medal - For gallantry with moderate risk"]
      },
      {
        id: "thanks-badge",
        title: isTamil ? "நன்றி பேட்ஜ்" : "Thanks Badge",
        subtitle: isTamil ? "சிறப்பு பங்களிப்பாளர்களுக்கான அங்கீகாரம்" : "Recognition for Special Contributors",
        imageSrc: "/Images/thanks.png",
        description: isTamil
          ? "இயக்கத்திற்கு சிறப்பு சேவை செய்த நண்பர்கள் மற்றும் நல்லெண்ணம் கொண்டவர்களுக்கு."
          : "For friends and well-wishers who have rendered special service to the Movement.",
        details: isTamil
          ? ["பாரத சாரணர் & சாரணியர் சின்னத்துடன் கூடிய வட்ட சட்டம்", "சீருடையில் அணியக்கூடாது", "சங்கத்தின் உறுப்பினர் தகுதியை வழங்காது"]
          : ["Circular frame with BSG emblem", "Must not be worn on uniform", "Does not confer membership of the Association"]
      }
    ]
  };



  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 via-white to-blue-50 mt-16">
      <div className="pt-24 pb-12">
        {/* Enhanced Header Section */}
        <div className="text-center mb-24 px-4">
          <h1 className="text-5xl md:text-6xl font-bold text-blue-900 mb-6 tracking-tight">
            {t.pageTitle}
          </h1>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6 rounded-full" />
          <p className="text-xl md:text-2xl text-blue-700 font-medium max-w-2xl mx-auto">
            {t.pageSubtitle}
          </p>
        </div>

        {/* Enhanced Main Content */}
        <div className="max-w-8xl mx-auto px-4">
          {Object.entries(awards).map(([category, categoryAwards]) => (
            <div key={category} className="mb-24">
              <div className="text-center mb-16">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4 tracking-tight">
                  {t.categories[category]}
                </h2>
                <div className="w-16 h-0.5 bg-blue-600/30 mx-auto" />
              </div>
              
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                {categoryAwards.map((award) => (
                  <div 
                    key={award.id}
                    className="group relative bg-white rounded-3xl shadow-lg overflow-hidden transform transition-all duration-500 hover:shadow-2xl"
                    onMouseEnter={() => setHoveredId(award.id)}
                    onMouseLeave={() => setHoveredId(null)}
                  >
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-600/5 to-purple-600/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                    
                    <div className="flex flex-col md:flex-row relative">
                      <div className="md:w-1/2 p-8 bg-gradient-to-br from-blue-50 to-blue-100/50">
                        <div className="aspect-square flex items-center justify-center p-4">
                          <img
                            src={award.imageSrc}
                            alt={award.title}
                            className={`max-h-64 object-contain transition-all duration-500 ${
                              hoveredId === award.id ? 'scale-110' : 'scale-100'
                            }`}
                          />
                        </div>
                      </div>
                      
                      <div className="md:w-1/2 p-8 flex flex-col">
                        <h3 className="text-2xl font-bold text-gray-900 mb-3 tracking-tight">
                          {award.title}
                        </h3>
                        <p className="text-blue-600 font-semibold mb-4 tracking-wide">
                          {award.subtitle}
                        </p>
                        <p className="text-gray-600 mb-6 leading-relaxed line-clamp-3">
                          {award.description}
                        </p>
                        <button
                          onClick={() => setSelectedAward(award)}
                          className="mt-auto bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 py-3 rounded-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-300 transform hover:translate-y-[-2px] active:translate-y-0 shadow-md hover:shadow-lg"
                        >
                          {t.readMore}
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Enhanced Modal */}
        {selectedAward && (
          <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50 transition-opacity duration-300">
            <div 
              className="bg-white rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="p-10">
                <div className="flex justify-between items-start mb-8">
                  <div>
                    <h3 className="text-3xl font-bold text-gray-900 mb-3 tracking-tight">
                      {selectedAward.title}
                    </h3>
                    <p className="text-blue-600 font-semibold tracking-wide">
                      {selectedAward.subtitle}
                    </p>
                  </div>
                  <button
                    onClick={() => setSelectedAward(null)}
                    className="text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-gray-100 rounded-full"
                  >
                    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                <div className="flex flex-col md:flex-row gap-10 mb-10">
                  <div className="md:w-1/2">
                    <div className="bg-gradient-to-br from-blue-50 to-blue-100/50 rounded-2xl p-8 flex items-center justify-center">
                      <img
                        src={selectedAward.imageSrc}
                        alt={selectedAward.title}
                        className="max-h-80 object-contain transform transition-transform duration-500 hover:scale-105"
                      />
                    </div>
                  </div>
                  <div className="md:w-1/2">
                    <h4 className="text-2xl font-semibold text-gray-900 mb-6">
                      {isTamil ? "விருது விவரங்கள்" : "Award Details"}
                    </h4>
                    <p className="text-gray-600 mb-8 leading-relaxed">
                      {selectedAward.description}
                    </p>
                    <div className="space-y-5">
                      {selectedAward.details.map((detail, index) => (
                        <div key={index} className="flex items-start group">
                          <div className="flex-shrink-0 w-2 h-2 mt-2 rounded-full bg-blue-600 mr-4 group-hover:scale-125 transition-transform duration-300"></div>
                          <p className="text-gray-600 leading-relaxed">{detail}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="border-t border-gray-100 pt-8">
                  <button
                    onClick={() => setSelectedAward(null)}
                    className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white py-4 rounded-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-300 transform hover:translate-y-[-2px] active:translate-y-0 shadow-md hover:shadow-lg font-medium tracking-wide"
                  >
                    {t.close}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AwardsPage;